/* eslint-disable no-unused-vars */
import { Grade as SaleProduct, ProductType } from '@/plugins/api'
export default {
  namespaced: true,
  state: {
    Leads: [],
    count: 0,
    products: []
  },
  actions: {
    async fetchProducts({ commit }, options) {
      const products = await SaleProduct.fetch({ ...options, _sort: 'academicLevelIndex:asc,divisionIndex:asc,createdAt:asc' })
      commit('changeState', {products})
      return products
    },
    async fetchProduct({ commit }, productId) {
      const product = await SaleProduct.fetchOne(productId)
      return product
    },
    async createProduct({ commit }, data) {
      const newProd = await SaleProduct.create(data)
      return newProd
    },
    async updateProduct({ commit }, { id, ...data }) {
      const updatedProd = await SaleProduct.update(id, { ...data })
      return updatedProd
    },
    async fetchProductTypes({ commit }, options) {
      const types = await ProductType.fetch({ ...options, _sort: 'index:ASC' })
      return types
    },
  },
  getters: {
    products: state => state.products
  }
}
/* eslint-enable no-unused-vars */
